import { lazy, Suspense } from "react";
import { useRoutes } from "react-router-dom";
import { Skeleton } from "antd";

import MainLayout from "@/layout/MainLayout";
import Page404 from "@/components/common/Page404";
import AppErrorBoundary from "@/components/common/AppErrorBoundary";
import AboutPage from "@/pages/AboutPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import CityProclamationsPage from "@/pages/CityProclamationsPage";
import SponsorsPartnersPage from "@/pages/SponsorsPartnersPage";
import TheMapPage from "@/pages/TheMapPage"

const ROUTE_FALLBACK = (
    <div style={{ minHeight: 320, padding: 24 }}>
        <Skeleton active paragraph={{ rows: 10 }} />
    </div>
);

const withRouteGuards = (element) => (
    <AppErrorBoundary>
        <Suspense fallback={ROUTE_FALLBACK}>{element}</Suspense>
    </AppErrorBoundary>
);

const loadIndex = () => import("@/pages/Index");
const loadGroupWalk = () => import("@/pages/GroupWalk");
const loadGroupMember = () => import("@/pages/GroupMember");
const loadWalk = () => import("@/pages/Walk");
const loadWalker = () => import("@/pages/Walker");
const loadSponsors = () => import("@/pages/Sponsors");
const loadSponsor = () => import("@/pages/Sponsor");
const loadEvents = () => import("@/pages/Events");

const Index = lazy(loadIndex);
const GroupWalk = lazy(loadGroupWalk);
const GroupMember = lazy(loadGroupMember);
const Walk = lazy(loadWalk);
const Walker = lazy(loadWalker);
const Sponsors = lazy(loadSponsors);
const Sponsor = lazy(loadSponsor);
const Events = lazy(loadEvents);

const NON_HOME_LOADERS = [
    loadGroupWalk,
    loadGroupMember,
    loadWalk,
    loadWalker,
    loadSponsors,
    loadSponsor,
    loadEvents,
];

const ROUTES = [
    { path: "/", element: withRouteGuards(<Index />) },
    { path: "country/:countryCode", element: withRouteGuards(<Index />) },
    { path: "country/:countryCode/city/:cityCode", element: withRouteGuards(<Index />) },
    { path: "group-walk/:id", element: withRouteGuards(<GroupWalk />) },
    { path: "group-member/:id", element: withRouteGuards(<GroupMember />) },
    { path: "walk/:id", element: withRouteGuards(<Walk />) },
    { path: "walker/:id", element: withRouteGuards(<Walker />) },
    { path: "sponsors", element: withRouteGuards(<Sponsors />) },
    { path: "sponsor/:id", element: withRouteGuards(<Sponsor />) },
    { path: "events", element: withRouteGuards(<Events />) },
    { path: "about", element: <AboutPage /> },
    { path: "how-it-works", element: <HowItWorksPage /> },
    { path: "city-proclamations", element: <CityProclamationsPage /> },
    { path: "sponsors-partners", element: <SponsorsPartnersPage /> },
    { path: "the-map", element: <TheMapPage /> },
    { path: "*", element: withRouteGuards(<Page404 />) },
];

const LAYOUT_ROUTES = [
    {
        element: <MainLayout />,
        children: ROUTES,
    },
];

export default function AppRoutesV2() {
    // usePrefetchRoutes(NON_HOME_LOADERS);
    return useRoutes(LAYOUT_ROUTES);
}